/**
 * ProjectControls Component
 * Save project and template selection controls
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Save, FileStack, Loader2 } from 'lucide-react';

export const ProjectControls = ({
  onSave,
  onOpenTemplates,
  isSaving = false,
  showLabels = true,
}) => {
  return (
    <div className="flex items-center gap-1">
      {/* Templates Button */}
      <Button
        variant="outline"
        size="sm"
        onClick={onOpenTemplates}
        className="border-zinc-700 px-2 md:px-3 hidden md:flex"
        data-testid="new-from-template-btn"
        title="New from Template"
      >
        <FileStack className="w-4 h-4" />
        {showLabels && <span className="ml-2 hidden lg:inline">Templates</span>}
      </Button>
      
      {/* Save Button - Prominent */}
      <Button
        variant="outline"
        size="sm"
        onClick={onSave}
        disabled={isSaving}
        className="border-cyan-500/40 bg-cyan-500/10 text-cyan-400 hover:bg-cyan-500/20 hover:text-white px-3"
        data-testid="save-project"
      >
        {isSaving ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <Save className="w-4 h-4" />
        )}
        <span className="ml-1.5 text-xs font-medium">{isSaving ? 'Saving...' : 'Save'}</span>
      </Button>
    </div>
  );
};

export default ProjectControls;
